import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcShrink = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.695205 14.3126C0.434855 14.0522 0.434855 13.6301 0.695205 13.3697L4.69383 9.37112L2.19395 9.37112C1.82576 9.37112 1.52728 9.07264 1.52728 8.70445C1.52728 8.33626 1.82576 8.03779 2.19395 8.03779L6.3033 8.03779C6.67149 8.03779 6.96997 8.33626 6.96997 8.70445L6.96997 12.8138C6.96997 13.182 6.67149 13.4805 6.3033 13.4805C5.93511 13.4805 5.63664 13.182 5.63664 12.8138L5.63664 10.3139L1.63801 14.3126C1.37766 14.5729 0.955554 14.5729 0.695205 14.3126Z",
		fill: "#A9AFBB"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.3059 6.47396C13.3059 6.84215 13.0074 7.14062 12.6392 7.14062L8.52989 7.14062C8.1617 7.14062 7.86323 6.84215 7.86323 6.47396L7.86323 2.3646C7.86323 1.99641 8.1617 1.69794 8.52989 1.69794C8.89808 1.69794 9.19656 1.99641 9.19656 2.3646L9.19656 4.86448L13.1952 0.865859C13.4555 0.60551 13.8776 0.60551 14.138 0.865859C14.3983 1.12621 14.3983 1.54832 14.138 1.80867L10.1394 5.80729L12.6392 5.80729C13.0074 5.80729 13.3059 6.10577 13.3059 6.47396Z",
		fill: "#A9AFBB"
	})]
});
export default SvgIcShrink;
